/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunHistory {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunHistory.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunHistory>): WellArchitectedFrameworkAssessmentRunHistory {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunHistory(), model);
        WellArchitectedFrameworkAssessmentRunHistory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunHistory>): WellArchitectedFrameworkAssessmentRunHistory {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunHistory.newInstance(<WellArchitectedFrameworkAssessmentRunHistory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunHistory) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunHistory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunHistory): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunHistory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.hyperscaler_milestone_number === undefined) {
            this.hyperscaler_milestone_number = 0;
        }
        if (typeof this.createdOn === "string") {
            this.createdOn = new Date(<string><any>this.createdOn);
        }
        if (typeof this.updatedOn === "string") {
            this.updatedOn = new Date(<string><any>this.updatedOn);
        }
        if (this.assessment_run) {
            models.RecordIdentity.fixupPrototype(this.assessment_run);
        }
        if (this.predecessor) {
            models.RecordIdentity.fixupPrototype(this.predecessor);
        }
        if (this.background_job) {
            models.RecordIdentity.fixupPrototype(this.background_job);
        }
        if (this.triggered_contexts) {
            for (let val of this.triggered_contexts) {
                models.WellArchitectedFrameworkAssessmentContext.fixupPrototype(val);
            }
        }
        if (this.policy_scans) {
            for (let val of this.policy_scans) {
                models.WellArchitectedFrameworkAssessmentRunPolicyScan.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the Assessment run history
     */
    sysId: string;

    /**
     * Assessment run created on
     */
    createdOn: Date;

    /**
     * Assessment run updated on
     */
    updatedOn: Date;

    /**
     * The Assessment Run this history is for
     */
    assessment_run: models.RecordIdentity;

    /**
     * Previous history entry
     */
    predecessor: models.RecordIdentity;

    /**
     * Contexts that triggered the scan
     */
    triggered_contexts: Array<models.WellArchitectedFrameworkAssessmentContext>;

    /**
     * Background job associated with a relevant scan. If null, background job has completed.
     */
    background_job: models.RecordIdentity;

    /**
     * Name of the milestone (only present if this history entry represents a milestone)
     */
    milestone: string;

    /**
     * Scans associated with this history step
     */
    policy_scans: Array<models.WellArchitectedFrameworkAssessmentRunPolicyScan>;

    /**
     * Milestone number
     */
    hyperscaler_milestone_number: number;

}
